import React, { useState } from 'react';
import { Form, Input, Button, Card, Typography, message } from 'antd';
import { MailOutlined, LeftOutlined } from '@ant-design/icons';
import { useNavigate, Link } from 'react-router-dom';
import api from '../../api/axios';

const { Title, Text } = Typography;

const ForgotPassword = () => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const onFinish = async (values) => {
        setLoading(true);
        try {
            await api.post('/forgot-password', values);
            message.success('Reset link sent to your email!');
        } catch (error) {
            message.error(error.response?.data?.message || 'Failed to send reset link');
        } finally {
            setLoading(false);
        }
    };

    const inputStyle = { background: 'transparent', border: '1px solid #444', color: '#fff', height: '45px', borderRadius: '8px' };

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: '#0D0D0D' }}>
            <Card style={{ width: 400, background: '#141414', borderRadius: '16px', border: '1px solid #333' }}>
                <div style={{ textAlign: 'center', marginBottom: 30 }}>
                    <Title level={3} style={{ color: '#fff' }}>Forgot Password?</Title>
                    <Text style={{ color: '#888' }}>Enter your email to receive a reset link.</Text>
                </div>

                <Form onFinish={onFinish} layout="vertical">
                    <Form.Item name="email" label={<Text style={{color: '#888'}}>Email Address</Text>} rules={[{ required: true, type: 'email' }]}>
                        <Input prefix={<MailOutlined style={{color: '#666'}} />} style={inputStyle} placeholder="example@mail.com" />
                    </Form.Item>

                    <Button type="primary" htmlType="submit" block loading={loading} style={{ background: '#fff', color: '#000', height: '45px', fontWeight: 'bold', border: 'none' }}>
                        Send Reset Link
                    </Button>

                    <div style={{ textAlign: 'center', marginTop: 20 }}>
                        <Link to="/login" style={{ color: '#FE1F08', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                            <LeftOutlined style={{ fontSize: '12px' }} /> Back to Login
                        </Link>
                    </div>
                </Form>
            </Card>
        </div>
    );
};

export default ForgotPassword;